import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoaderForImage from "../../LoaderForImage";
import upploadImage from "../../../assets/images/upload-video.png";
import { imageUpload } from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { useDispatch } from "react-redux";
import { editPrize } from "../../../features/slices/challanges";
const initailState = {
  name: "",
  prizeNo: "",
  description: "",
  image: "",
  id: "",
};
const EditPrize = () => {
  const [iState, setUpdateState] = useState(initailState);
  const [imageLoader, setImageLoader] = useState(false);
  const { name, prizeNo, description, image } = iState;
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setUpdateState((prev) => ({
      ...prev,
      name: state?.name,
      prizeNo: state?.prizeNo,
      description: state?.description,
      image: state?.image,
      id: state?._id,
    }));
  }, []);
  const handleChange = (e) => {
    const { name, value } = e?.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setUpdateState({
            ...iState,
            [e.target.name]: res?.payload?.url,
          });
          setImageLoader(false);
        } else {
          toastService.error("Failed to upload");
          setImageLoader(false);
        }
      });
    }
  };
  const handleUpdate = () => {
    dispatch(editPrize(iState)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Prize updated successfully");
        navigate("/challenges/viewPrizeDetails");
      } else {
        toastService.error("Failed to update prize");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit New Prize</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Prize Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize Name"
                name="name"
                value={name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Prize No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize No."
                name="prizeNo"
                value={prizeNo}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Prize Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize Description"
                name="description"
                value={description}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Image</h4>
          </div>
          <div className="CommonForm">
            {imageLoader ? (
              <LoaderForImage />
            ) : (
              <div
                className="UploadBox Image"
                style={{
                  position: "relative",
                  zIndex: 0,
                }}
              >
                <span>
                  {!image && <img src={upploadImage} />}
                  {image && (
                    <>
                      <img
                        src={image}
                        alt=""
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          mixBlendMode: "darken",
                        }}
                      />
                      <i
                        className="fas fa-edit"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "#fff",
                          background: "rgba(0, 0, 0, 0.6)",
                          borderRadius: "50%",
                          padding: "5px",
                          zIndex: 2, // Place icon above the video
                          cursor: "pointer",
                        }}
                        // Trigger file input on icon click
                      />
                    </>
                  )}
                </span>
                <input type="file" name="image" onChange={handleImage} />
                <p>
                  <label>Click to upload</label> or <br /> drag &amp; drop
                </p>
              </div>
            )}
          </div>
          <button className="Button" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPrize;
